export default __webpack_public_path__ + "static/AdobeStock_203384096-98d88f7fcc4b55f97614af00a5e6359d.jpg";